import { makeStyles } from "@material-ui/core/styles";
import tinycolor from "tinycolor2";
import { colorConstant } from "../style/Color.constant";

export default makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "#000",
    opacity: 0.5 + "!important",
  },
  modalBody: {
    backgroundColor: "#fff",
  },
  modalTitle: {
    background: "#e4fffe",
    padding: ".3em 0em .3em 1em",
    fontSize: "1.3em",
    borderTopLeftRadius: ".4em",
    borderTopRightRadius: ".4em",
  },
  modalContent: {
    textAlign: "left",
    padding: "1em",
    marginBottom: 0,
  },
  modalFooter: {
    textAlign: "right",
    padding: "1em",
  },
  paper: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #dbdbdb",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0, 0, 1),
    borderRadius: ".4em",
    "&:focus": {
      outline: "none",
    },
  },
  paper800: {
    position: "absolute",
    width: 800,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #dbdbdb",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0, 0, 1),
    borderRadius: ".4em",
  },
  paper600: {
    position: "absolute",
    width: 600,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #dbdbdb",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0, 0, 1),
    borderRadius: ".4em",
  },
  paper700: {
    position: "absolute",
    width: 700,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #dbdbdb",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0, 0, 1),
    borderRadius: ".4em",
  },
  paperAuto: {
    position: "absolute",
    width: 1000,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #dbdbdb",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0, 0, 1),
    borderRadius: ".4em",
    height: "auto",
  },
  paper1200: {
    position: "absolute",
    width: 1000,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #dbdbdb",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0, 0, 1),
    borderRadius: ".4em",
    overflowY: "scroll",
    height: 500,
    overflowX: "hidden",
  },
  deActivateButton: {
    textTransform: "capitalize",
    backgroundColor: "#014e8c",
    border: "1px solid  #014e8c",
    color: "#fff",
  },
  resetButton: {
    background: "#014e8c",
    color: "#fff",
    textTransform: "capitalize",
  },
  width100: {
    width: "100%",
    textAlign: "left",
  },
  cancelButton: {
    marginRight: "1em",
    color: "#014e8c",
    textTransform: "capitalize",
    border: "1px solid  #014e8c",
  },
  deleteButton: {
    marginRight: "1em",
    color: "#ff0000",
    textTransform: "capitalize",
    border: "1px solid  #ff0000",
  },
  bold: {
    fontWeight: "bold",
    color: "#212121",
    textTransform: "capitalize",
  },
  snackbarRoot: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  layoutContainer: {
    height: 200,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: theme.spacing(2),
    border: "1px dashed",
    borderColor: theme.palette.primary.main,
    position: "relative",
  },
  layoutText: {
    color: tinycolor(theme.palette.background.light).darken().toHexString(),
  },
  layoutButtonsRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  layoutButton: {
    backgroundColor: theme.palette.background.light,
    width: 125,
    height: 50,
    outline: "none",
    border: "none",
  },
  layoutButtonActive: {
    backgroundColor: tinycolor(theme.palette.background.light)
      .darken()
      .toHexString(),
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginTop: theme.spacing(2),
  },
  notificationCallButton: {
    color: "white",
    marginBottom: theme.spacing(1),
    textTransform: "none",
  },
  codeContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(2),
  },
  codeComponent: {
    flexGrow: 1,
  },
  notificationItem: {
    marginTop: theme.spacing(2),
  },
  notificationCloseButton: {
    position: "absolute",
    right: theme.spacing(2),
  },
  toastsContainer: {
    width: 400,
    marginTop: theme.spacing(6),
    right: 0,
  },
  progress: {
    visibility: "hidden",
  },
  formFields: {
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.17,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#212121",
  },
  notification: {
    display: "flex",
    alignItems: "center",
    background: "transparent",
    boxShadow: "none",
    overflow: "visible",
  },
  notificationComponent: {
    paddingRight: theme.spacing(4),
  },
  errortoaster: {
    backgroundColor: colorConstant.errorToaster,
    // borderRadius: 40,
    textAlign: "center",
    fontSize: 12,
  },
  successtoaster: {
    backgroundColor: colorConstant.successToaster,
    // borderRadius: 40,
    textAlign: "center",
    fontSize: 12,
  },
  infotoaster: {
    backgroundColor: colorConstant.infoToaster,
    // borderRadius: 40,
    fontSize: 12,
    textAlign: "center",
  },
  successlongtoaster: {
    backgroundColor: colorConstant.successToaster,
    textAlign: "center",
    fontSize: 12,
  },
  inputfile: {
    width: "0.1px",
    height: "0.1px",
    opacity: 0,
    overflow: "hidden",
    position: "absolute",
    zIndex: -1,
  },
  uploadLabel: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  defaultBorder: {
    border: "1px dashed #79b9ff",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  errorBorder: {
    border: "1px dashed #FF0000",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  suspensePrinting: {
    float: "left",
  },
  addSuspense: {
    marginTop: "1em",
  },
  editBorder: {
    borderBottom: "1px solid #007bff",
    "&:focus": {
      borderBottom: "1px solid #007bff",
    },
  },
  cancelStyle: {
    marginTop: ".5em",
  },

  uploadIcon: {
    marginRight: "1em",
  },
  userBadge: {
    textAlign: "left",
    fontWeight: "bold",
    textTransform: "capitalize",
    fontSize: "1.3em",
  },
  noteDesc: {
    textAlign: "left",
    fontSize: 12,
    wordBreak: "break-all",
  },
  alignItem: {
    alignItems: "center",
  },
  azure: {
    backgroundColor: "#03a9f4",
    textTransform: "uppercase",
  },
  toastCustomContainer: {
    marginTop: "1em",
  },
  menuItem: {
    fontSize: 12,
  },
  tabSubTitle: {
    fontWeight: "bold",
    paddingTop: 15,
    paddingBottom: 15,
    textAlign: "left",
  },
  simpleTitle: {
    fontSize: "16px",
    fontWeight: "bold",
    paddingTop: "0.5em",
    textAlign: "left",
    cursor: "pointer",
  },
  errorDanger: {
    color: "red",
  },
  greenSuccess: {
    color: "green",
  },
  floatingButton: {
    position: "fixed",
    right: 20,
    bottom: 20,
    backgroundColor: "#014e8c",
  },
  menuPopup: {
    marginTop: "-4em",
  },
  autoDropdown: {
    fontSize: "12px !important",
    marginTop: ".4em",
  },
  autoComplete: {
    fontSize: "12px !important",
    marginTop: ".4em",
    borderBottom: "1px solid #81d4fa !important",
  },
  autoDropdownroot: {
    fontSize: "12px !important",
    marginTop: ".4em",
  },
  paper1100: {
    position: "absolute",
    width: 1100,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #dbdbdb",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0, 0, 1),
    borderRadius: ".4em",
  },
  modalFooterPadding: {
    display: "flex",
    justifyContent: "space-between",
    padding: "1em",
  },
}));
